<div id="home" class="tab-pane fade in active myAttendance"  [intouchloader2]="isLoader">
    <div class="attendCal customMonthCal">
       
        <span><i class="material-icons">today</i><ng-month-picker [displayFormat]="'MMMM-YY'" [showIcon]="false" [(ngModel)]="myVar" ></ng-month-picker></span>

      
        <ul class="leaveStatusList">
            <li><span class="colorDots leaveDot05"></span>Approved</li>
            <li><span class="colorDots leaveDot03"></span>Pending</li>
            <li><span class="colorDots leaveDot04"></span>Rejected</li>
         </ul>
    </div>
    <ul class="caldBtmIcon">
        <li (click)="changeView();" ><a href="#" class="calenderToggle"><i class="material-icons-outlined">event_available</i></a></li>
        <!-- <li><a href="#" class="fullscreenToggle"><i class="material-icons">fullscreen</i></a></li> -->
    </ul>

    <div class="attendTable">
    <div class="reportpanel myAttendTable01 mCustomScrollbar" data-mcs-theme="minimal-dark">
      
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">
                            <p>Date</p>
                        </th>
                        <th scope="col">
                            <p>Attendance</p>
                        </th>
                        <th scope="col">
                            <p>Status</p>
                        </th>
                        <th scope="col">
                            <p>Remarks</p>
                        </th>
                        <th scope="col">
                            <p>Start and End Work Timing</p>
                        </th>
                        <th scope="col">
                            <p>Total Hours</p>
                        </th>

                    </tr>
                </thead>
                <tbody *ngIf="myAttendanceList.length==0  &&  !isLoader  ">
                    <tr>
                        <div class="nodataDiv" >
                            <span class="nodataimg"><img src="assets/img/nodataImg.png" alt=""></span>
                            <p>No Attendance Marked</p>
                           
                        </div>
                    </tr>
                </tbody>
                <tbody>
                    <!-- <cdk-virtual-scroll-viewport itemSize="8" class="example-viewport"> -->
                    <!-- <tr *cdkVirtualFor="let attendance of myAttendanceList"> -->
                        <tr *ngFor="let attendance of myAttendanceList |orderBy: 'timeForSort': false; let i = index;">
                        <td>
                            <p>{{attendance.dateStr}}</p>
                        </td>
                        <td>
                            <p>{{attendance.attendanceStr}}</p>
                        </td>
                        <td>
                            <p class="{{attendance.statusClass}}">{{attendance.statusStr}}</p>
                        </td>
                        <td *ngIf="attendance.status == 1; else remarkBlock"> 
                            <input (blur)="onBlurMethod(attendance, $event.target.value)" class="textInput" type="text" name="remark{{i}}" [(ngModel)]="attendance.remark">
                        </td>
                        <ng-template #remarkBlock>
                            <td>
                                <p>{{attendance.remark}}</p>
                            </td>
                        </ng-template>

                        <td>
                            <div class="tableInfo">
                            <p>{{attendance.startEndTimingStr}}</p>

                        <a href="#" class="tip1 infoIcon" attr.data-tip="tooltip{{i}}"
                            data-placement="bottom" *ngIf="attendance.attendanceOfDay && attendance.attendanceOfDay.length>0">  
                            <img src="assets/img/infoIcon.png" alt="">
                         </a>
                         <!-- <div id="tooltip{{i}}" class="tip-content hidden" style="display: none;">
                            <div class="tooltipSec">
                               <p>hkjhkhkhk</p>
                             
                            </div>
                         </div> -->
                         <div id="tooltip{{i}}" class="tip-content hidden" style="display: none;">
                            <div class="tooltipSec">
                                 <ul class="tooltipNameList">
                                    <li *ngFor ="let obj of attendance.attendanceOfDay">{{obj.attendanceStr}}</li>
                                    
                                 </ul>
                                  
                     
                            </div>
                      </div>
                         </div>
                        </td>

                        <td>
                            <p>{{attendance.totalHrsStr}}</p>
                        </td>

                    </tr>

                    <!-- </cdk-virtual-scroll-viewport> -->
                   

                </tbody>
            </table>
        </div>
    </div>
    </div>

    <div class="attendCalenderDiv">
        <full-calendar id="calendar" #fullCalender deepChangeDetection="true" [options]="calendarOptions"></full-calendar>
     </div>
</div>

